import { render, staticRenderFns } from "./order_online.vue?vue&type=template&id=57298a93&scoped=true"
import script from "./order_online.vue?vue&type=script&lang=js"
export * from "./order_online.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57298a93",
  null
  
)

export default component.exports